import { render } from "./Header.vue?vue&type=template&id=7179fa5c&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "@/styles_mobile/noir-header.css?vue&type=style&index=0&id=7179fa5c&scoped=true&lang=css&external"

import exportComponent from "../../../../../../../../../../../../private/tmp/codex-user-modern-deps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7179fa5c"]])

export default __exports__